import bilAPI from "./api";
import { supportFormData } from "../utils/helpers/supportFiles";

// The site side of support (backend apps/support, /api/v1/support/tickets/):
// a signed-in user's own tickets. Every write answers with the whole ticket
// (thread included), so callers replace their state with the response.
//
// Multipart writes set the Content-Type explicitly: bilAPI defaults to JSON,
// and axios 1.x would otherwise serialize the FormData — files included — as
// JSON and drop them.
const MULTIPART = { "Content-Type": "multipart/form-data" };

export const getSupportTickets = ({ params: { page } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/support/tickets/`, { params: { page }, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const getSupportTicket = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/support/tickets/${uuid}/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// body: { subject, category, body, page_url, files: File[] }
export const createSupportTicket = ({ body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/support/tickets/`, supportFormData(body), { signal, headers: MULTIPART })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// body: { body, files: File[] }. Writing into a closed ticket reopens it.
export const postSupportMessage = ({ uuid, body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/support/tickets/${uuid}/messages/`, supportFormData(body), {
          signal,
          headers: MULTIPART,
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// body: { body }. The author rewrites the text of one of their own messages
// (`can_edit`); attachments stay. Nothing turns unread and the ticket keeps
// its status. Answers with the whole ticket.
export const editSupportMessage = ({ uuid, messageUuid, body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/support/tickets/${uuid}/messages/${messageUuid}/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const markSupportTicketRead = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/support/tickets/${uuid}/read/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const closeSupportTicket = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/support/tickets/${uuid}/close/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// -> { count }: tickets with a support reply the user has not opened yet.
export const getSupportUnreadCount = ({ signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/support/tickets/unread-count/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
